export const siteInfo = {
  name: "91直播平台资讯站",
  tagline: "相关资讯、使用说明与安全提示",
  description:
    "91直播平台相关资讯、常见问题、版本辨别与使用说明，帮助用户识别虚假页面、恶意下载和隐私风险。访问或下载前请确认来源可靠，并遵守当地法律法规。",
  url: "",
  logo: "",
  aboutUs: {
    title: "关于我们",
    content: `<p>91直播平台资讯站致力于为用户提供全面、准确、及时的91直播平台相关信息。我们整理平台的最新动态、使用教程、安全提示和常见问题，帮助用户安全、便捷地使用直播服务。</p>
<p>在信息繁杂的网络环境中，用户面临着虚假页面、恶意下载和隐私泄露等多重风险。我们的使命是通过专业的内容整理和信息甄别，帮助用户识别真伪、规避风险、安心使用。</p>
<p>我们的团队由资深的互联网安全专家和内容创作者组成，持续关注直播行业的发展动态，及时更新网站内容，确保信息的时效性和准确性。</p>`,
    reputation: {
      title: "品牌信誉",
      items: [
        {
          title: "信息可靠",
          description: "所有内容均经过多方核实，确保信息的真实性和可靠性。",
          icon: "ri-verified-badge-line",
        },
        {
          title: "更新及时",
          description: "紧跟平台动态和行业趋势，持续更新内容，保持信息时效性。",
          icon: "ri-refresh-line",
        },
        {
          title: "用户至上",
          description: "以用户需求为导向，提供实用、易懂的内容和良好的浏览体验。",
          icon: "ri-heart-line",
        },
        {
          title: "安全第一",
          description: "网站采用安全加密协议，保护用户浏览隐私，杜绝信息泄露风险。",
          icon: "ri-lock-line",
        },
      ],
    },
    contact: {
      title: "联系我们",
      email: "contact@91zhibo-info.example.com",
      wechat: "91zhibo_kefu",
      qq: "1234567890",
      address: "中国",
      workingHours: "周一至周五 9:00-18:00",
    },
  },
};